export default __webpack_public_path__ + "static/media/warning--entering-roadway-merge--g1.332dc1ff.png";